import React from 'react';
import { useTranslation } from 'react-i18next';
import { CFormSelect } from '@coreui/react';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (e) => {
        const lang = e.target.value;
        i18n.changeLanguage(lang);
    };

    return (
        <CFormSelect 
            size="sm" 
            value={i18n.language} 
            onChange={changeLanguage} 
            style={{ width: 'auto', display: 'inline-block', marginLeft: '10px' }}
            aria-label="Select language"
        >
            <option value="ru">🇷🇺 RU</option>
            <option value="en">🇺🇸 EN</option>
        </CFormSelect>
    );
};

export default LanguageSwitcher;